/**
 * The transaction a url's render key names (`id-12`, `plaid-abc`, `submit-xyz`, as
 * TransactionRenderKey writes them), or null when the finder has nothing by that key.
 */
export default function findTransactionByRenderKey(transactionFinder, key) {
	if(!transactionFinder || !key) {
		return null;
	}
	const separator = key.indexOf('-');
	const type = key.slice(0, separator);
	const id = key.slice(separator + 1);
	switch(type) {
		case 'plaid': {
			const found = transactionFinder.plaidTransactions.getTransactionById(id);
			return found ? found.createTransaction() : null;
		}
		case 'id':
			return transactionFinder.getTransactionById(id);
		case 'submit':
			return transactionFinder.getTransactionBySubmitId(id);
		default:
			return null;
	}
}
